import { useIsBreakpoint } from '../../utils/useBreakpoint'
import { Container } from '../Container/Container'
import './Juicer.css'

export function JuicerComponent() {
  const isLargerThan480 = useIsBreakpoint(480)
  const postsPerColumn = isLargerThan480 ? 3 : 2

  return (
    <Container>
      <ul
        className="juicer-feed"
        data-feed-id="CeramolAcn3"
        data-per={postsPerColumn}
        data-columns={postsPerColumn}
      />
    </Container>
  )
}
